import {CardProps, theme} from "antd";

export const useAgentNewStepCardStyles = (): CardProps["styles"] => {
    const {token} = theme.useToken();

    return {
        header: {
            color: token.colorTextSecondary,
            height: 40,
        },
        body: {
            paddingTop: token.paddingLG,
        },
    };
};
